import React from "react";
import { Box, Checkbox, CircularProgress, Typography } from "@mui/material";
import { Link, Navigate } from "react-router-dom";
import LinkIcon from "@mui/icons-material/Link";
import { useMessages } from "./MessagesContext";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import AllMessageLogs from "./AllMessageLogs";

const isActiveMessage = (message) => {
  if (
    message.expirationDate === null ||
    new Date(message.expirationDate) > new Date()
  ) {
    return true;
  } else return false;
};

const MessagesList = () => {
  const {
    messages,
    setSelectedMessage,
    setSelectedMessageLog,
    authenticationChecked,
  } = useMessages();
  const [error, setError] = React.useState("");

  const viewEditLinkIcon = (item) => {
    return (
      <Link
        className="hyper-links"
        onClick={(e) => {
          setSelectedMessage(item);
        }}
      >
        {item.id}
      </Link>
    );
  };

  const messageLogLink = (item) => {
    return (
      <Link
        style={{ textDecoration: "none" }}
        className="hyper-links"
        onClick={(e) => {
          setSelectedMessageLog(item);
        }}
      >
        <LinkIcon fontSize="medium" sx={{ alignItems: "center" }} />
      </Link>
    );
  };

  const convertDateISOToUTC = (isoDate) => {
    if (isoDate !== null && isoDate !== "") {
      const date = new Date(isoDate);
      // const utcFormatted = `${date.getUTCFullYear()}-${String(date.getUTCMonth()+1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')} ${String(date.getUTCHours()).padStart(2, '0')}:${String(date.getUTCMinutes()).padStart(2, '0')}:${String(date.getUTCSeconds()).padStart(2, '0')}`;
      const localDate = new Date(isoDate).toLocaleString();
      return localDate;
    } else return "";
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
        <div style={{ flex: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const dataGridColumns = [
    {
      field: "id",
      headerName: "Id",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 100,
      renderCell: (params) => viewEditLinkIcon(params.row),
    },
    {
      field: "text",
      headerName: "Text",
      filterable: true,
      sortable: false,
      flex: 1,
      minWidth: 500,
      renderCell: (params) => {
        return (
          <div>
            <span dangerouslySetInnerHTML={{ __html: params.row.text }}></span>
          </div>
        );
      },
    },
    {
      field: "priority",
      headerName: "Priority",
      filterable: true,
      sortable: true,
      flex: 0.2,
      minWidth: 50,
    },
    {
      field: "active",
      headerName: "Active",
      filterable: false,
      sortable: false,
      flex: 0.2,
      minWidth: 50,
      renderCell: (params) => (
        <Checkbox disabled checked={isActiveMessage(params.row)}></Checkbox>
      ),
    },
    {
      field: "expirationDate",
      headerName: "Expiration Date",
      filterable: true,
      sortable: true,
      flex: 0.5,
      minWidth: 50,
      renderCell: (params) => convertDateISOToUTC(params.row.expirationDate),
    },
    // {
    //     field:'logs',
    //     headerName:'Logs',
    //     filterable:false,
    //     sortable:false,
    //     flex: 0.2,
    //     minWidth: 10,
    //     renderCell:(params) => messageLogLink(params.row)
    // }
  ];

  if (messages !== null) {
    if (messages.length > 0)
      return (
        <>
          <DataGrid
            rows={messages}
            columns={dataGridColumns}
            autoHeight
            getRowHeight={() => "auto"}
            disableSelectionOnClick
            components={{
              Toolbar: CustomToolbar,
            }}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                fontSize: "1rem",
                fontWeight: "bold",
                display: "flex",
              },

              "& .MuiDataGrid-cell": {
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.2em",
              },
            }}
          />
          <AllMessageLogs />
        </>
      );
    else
      return (
        <Typography sx={{ textAlign: "center", m: 2 }} variant="h5">
          {error ? error : "No Data Found"}
        </Typography>
      );
  } else {
    if (authenticationChecked === "Success") {
      return (
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <CircularProgress />
        </Box>
      );
    }
    if (authenticationChecked === "UNAUTHORIZED") {
      const wasAdminLoggedIn = sessionStorage.getItem("isAdmin") === "true";
      const isUserLoggedIn = sessionStorage.getItem("isUser") === "true";
      if (isUserLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            You are not authorized to view this page.
          </Typography>
        );
      else if (wasAdminLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            Session expired.{" "}
            <Link to="/About/AdminLogin" className="hyper-links">
              <b>Click here to log back in</b>
            </Link>
          </Typography>
        );
      else return <Navigate to="/About/AdminLogin" replace />;
    }
    if (authenticationChecked === "FORBIDDEN")
      return <Navigate to="/About/AdminLogin" replace />;
  }
};

export default MessagesList;
